// extracted by mini-css-extract-plugin
export default {"usage":"Usage_usage__xXaXI","content":"Usage_content__kkcAp","title":"Usage_title__R1mJD","value":"Usage_value__UHVpi"};